<template>
  <img alt="gub" src="./assets/gub.jpg" class="gub">
  <h1 class="title">GUBGUBGUB</h1>
  <h1 class="title">WE <span style="color: red">LOVE</span> YOU</h1>
</template>

<script>
export default {
  name: 'App',
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.title {
  z-index: 1000;
  font-size: 10vw;
  color: white;
  width: 100vw;
  height: 20vh;
}
.gub {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: -1000;
}
</style>
